import {Pipe, PipeTransform} from '@angular/core';

/**
 * The YouTubeUrlPipe will extract the YouTube video id from a given url.
 */
@Pipe({name: 'youTubeUrl'})
export class YouTubeUrlPipe implements PipeTransform {
  transform(url: any, ...args: any[]): any {
    let videoId: string;
    if (!!url) {
      const urlParts: string[] = url.split('/');
      if (urlParts.length > 1) {
        videoId = this.extractIdFromParameter(urlParts.pop());
      }
    }
    return videoId;
  }

  private extractIdFromParameter(videoId: string): string {
    const paramParts: string[] = videoId.split('v=');
    if (paramParts.length > 1) {
      videoId = paramParts.pop();
    }

    videoId = this.trimAdditionalParameters('&', videoId);
    videoId = this.trimAdditionalParameters('?', videoId);

    return videoId.length > 0 ? videoId : undefined;
  }

  private trimAdditionalParameters(delimiter: string, param: string): string {
    const delimiterPosition: number = param.indexOf(delimiter);
    if (delimiterPosition > 0) {
      param = param.substring(0, delimiterPosition);
    }
    return param;
  }
}
